<template>
  <div>
    <v-flex>
      <v-snackbar
        v-model="dialog.snackbar"
        top
        right
        color="#ff64ad">
        <span class="body-1 font-weight-light white--text"
          v-html="message.success">
        </span>

        <template v-slot:action="{ attrs }">
          <v-btn
            class="body-1 font-weight-bold text-capitalize"
            color="white"
            icon
            v-bind="attrs"
            @click="dialog.snackbar = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="dialog.zoom"
        @keydown.esc="dialog.zoom = false"
        :fullscreen="dialog.fullscreen"
        width="1450"
        persistent
        scrollable>
        <v-card 
          class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span v-if="selected.zoom_array.length > 0"
              class="mt-1 ml-1">
              Data Dukung Pengiriman
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.zoom = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <v-card-text v-if="selected.zoom_array.length > 0"
            class="py-0 pa-4">
            <v-row>
              <v-col
                cols="12"
                md="12">
                <v-card 
                  flat
                  style="border-radius: 10px;">
                  <v-carousel
                    cycle
                    interval="500000"
                    prev-icon="mdi-arrow-left-thick"
                    next-icon="mdi-arrow-right-thick"
                    show-arrows-on-hover
                    :height="dialog.fullscreen ? '89vh' : '77vh'"
                    v-model="selected.zoom_index">
                    <v-carousel-item
                      v-for="(item, index) in selected.zoom_array"
                      :key="index">
                      <div v-if="!dialog.fullscreen"
                        class="on_hover_rotate text-center">
                        <v-img
                          :style="`transform: rotate(${rotation}deg); transition: transform 0.5s ease-in-out;`"
                          contain
                          width="100%"
                          height="70vh"
                          alt="vuetify"
                          :src="item.file">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#ff64ad">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>

                        <div
                          class="on_hover_btn">
                          <v-btn 
                            @click="rotateLeft"
                            elevation="0"
                            color="#b2b2b2"
                            fab
                            small
                            class="mx-4 white--text">
                            <v-icon>mdi-restore</v-icon>
                          </v-btn>

                          <v-btn 
                            @click="rotateRight"
                            elevation="0"
                            color="#b2b2b2"
                            fab
                            small
                            class="mx-4 white--text">
                            <v-icon>mdi-reload</v-icon>
                          </v-btn>
                        </div>
                      </div>

                      <div v-if="dialog.fullscreen"
                        class="on_hover_rotate text-center">
                        <v-zoomer
                          :doubleClickToZoom="true"
                          style="width: 100%; height: 92vh; cursor: pointer;">
                          <v-img 
                            :style="`transform: rotate(${rotation}deg); transition: transform 0.5s ease-in-out; width: 100%;`"
                            style="object-fit: contain; width: 100%; height: 100%;"
                            contain
                            alt="vuetify"
                            :src="item.file">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  color="#ff64ad">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-zoomer>

                        <div
                          class="on_hover_btn">
                          <v-btn 
                            @click="rotateLeft"
                            elevation="0"
                            color="#b2b2b2"
                            fab
                            small
                            class="mx-4 white--text">
                            <v-icon>mdi-restore</v-icon>
                          </v-btn>

                          <v-btn 
                            @click="rotateRight"
                            elevation="0"
                            color="#b2b2b2"
                            fab
                            small
                            class="mx-4 white--text">
                            <v-icon>mdi-reload</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-carousel-item>
                  </v-carousel>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.verif"
        @keydown.esc="dialog.verif = false"
        :fullscreen="dialog.fullscreen"
        width="750"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Terima / Tolak Pengiriman
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.verif = false"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>

          <ValidationObserver ref="form">
            <v-form class="text-left">
              <v-container>
                <v-row
                  align="center"
                  justify="center">
                  <v-col 
                    cols="12"
                    md="6">
                    <v-card
                      flat
                      class="pa-4 pb-0">
                      <v-img
                        contain
                        class="ma-auto"
                        width="150"
                        height="150"
                        alt="vuetify"
                        :src="require('@/assets/image/pos_terima.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="#ff64ad">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <v-card-text
                        class="text-center line-text-second mt-4"
                        style="height: 130px;">
                        <span>
                          Jika Anda menerima ajuan pengiriman ini, berkas akan diteruskan ke PT. POS INdoensia untuk dikirimlan ke alamat penerima.
                        </span>
                      </v-card-text>

                      <v-card-actions>
                        <v-btn
                          @click="save('DIPROSES')"
                          :loading="process.form"
                          :disabled="process.form"

                          block
                          elevation="0"
                          color="green"
                          class="body-2 font-weight-bold text-capitalize white--text">
                          Terima Pengiriman
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>

                  <v-col 
                    cols="12"
                    md="6">
                    <v-card
                      flat
                      class="pa-4 pb-0">
                      <v-img
                        contain
                        class="ma-auto"
                        width="150"
                        height="150"
                        alt="vuetify"
                        :src="require('@/assets/image/pos_tolak.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="#ff64ad">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <v-card-text
                        class="text-center line-text-second mt-4"
                        style="height: 130px;">
                        Jika Anda menolak ajuan ini, silahkan Anda masukkan alasan kenapa Anda menolak ajuan pengiriman tersebut.
                      </v-card-text>

                      <v-card-actions>
                        <v-btn
                          @click="dialog.verif = false; dialog.rejected = true;"
                          block
                          elevation="0"
                          color="red"
                          class="body-2 font-weight-bold text-capitalize white--text">
                          Tolak Pengiriman
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </ValidationObserver>

          <v-alert 
            type="error" 
            text dense prominent 
            class="mt-6"
            v-show="message.error.length > 0">
            {{  message.error }}
          </v-alert>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.rejected"
        @keydown.esc="dialog.rejected = false"
        :fullscreen="dialog.fullscreen"
        width="750"
        persistent
        scrollable>
        <v-card class="border-radius pa-2">
          <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
            <v-avatar size="35">
              <v-img
                contain
                width="30"
                height="30"
                alt="vuetify"
                :src="require('@/assets/logo/favicon.png')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#ff64ad">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>

            <span class="mt-1 ml-1">
              Tolak Pengiriman
            </span>

            <v-spacer/>

            <v-icon 
              @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
              class="cursor-pointer mr-1"
              size="24"
              color="#ff64ad">
              {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
            </v-icon>

            <v-icon 
              @click="dialog.rejected = false; dialog.verif = true;"
              class="cursor-pointer"
              size="24"
              color="red">
              mdi-close-circle-outline
            </v-icon>
          </v-card-title>

          <v-divider class="mx-4 mt-3 mb-2"/>
          
          <v-list 
            color="transparent">
            <v-list-item>
              <v-list-item-avatar
                size="45"
                tile>
                <v-img
                  :src="require('@/assets/image/pos_tolak.png')"
                  style="border-radius: 10px;">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        color="#ff64ad">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  class="body-1 font-weight-bold mb-2">
                  Input Alasan
                </v-list-item-title>

                <v-list-item-subtitle
                  class="font-weight-light">
                  Silahkan masukkan alasan penolakan ajuan pengiriman tersebut.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-card-text
            class="px-4 pb-3 mt-2">
            <ValidationObserver ref="form">
              <v-form class="text-left">
                <div
                  class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Alasan Penolakan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <quill-editor 
                  ref="myTextEditor"
                  :options="{
                    placeholder: 'Contoh. Potongan KTP palsu'
                  }"
                  v-model="form.delivery[0].note">
                </quill-editor>
                
                <v-alert 
                  type="error" 
                  text dense prominent 
                  class="mt-6"
                  v-show="message.error.length > 0">
                  {{  message.error }}
                </v-alert>
              </v-form>
            </ValidationObserver>
          </v-card-text>

          <v-divider class="mx-4 mb-3 mt-2"/>

          <v-card-actions>
            <v-spacer/>

            <v-btn
              @click="save('DITOLAK')"
              :loading="process.form"
              :disabled="process.form"
              
              color="#ff64ad"
              elevation="0"
              class="body-2 font-weight-bold text-capitalize white--text">
              <v-icon small class="mr-1">mdi-check-bold</v-icon>
              Simpan
            </v-btn>

            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text"
              :disabled="process.form"
              @click="dialog.rejected = false; dialog.verif = true;">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
              Batal
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <section>
        <v-row v-if="process.load && Object.keys(detail).length < 1">
          <v-col 
            cols="12"
            md="3"
            class="pb-0">
            <v-skeleton-loader
              type="article, list-item-three-line">
            </v-skeleton-loader>
          </v-col>

          <v-col 
            cols="12"
            md="9"
            class="pb-0">
            <v-skeleton-loader
              type="article, list-item-three-line, article, list-item-three-line, article, article, list-item-three-line">
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <div v-if="!process.load && Object.keys(detail).length > 0"
          class="pb-0">
          <v-row>
            <v-col 
              cols="12"
              md="3"
              class="pb-0">
              <div @click="$router.go(-1)"
                class="d-flex align-center color-first cursor-pointer mb-4">
                <v-icon color="#ff64ad">mdi-arrow-left-thick</v-icon>
            
                <span class="body-1 ml-1">
                  Kembali
                </span>
              </div>

              <v-card
                class="my-2 pa-2"
                style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
                      border-radius: 10px;">
                <v-card-text
                  class="text-center pb-0">
                  Penerima Produk
                </v-card-text>

                <v-card-title
                  class="d-flex justify-center font-weight-bold">
                  <span
                    class="one-line">
                    {{ detail.delivery_receiver.name }}
                  </span>
                </v-card-title>

                <v-card-subtitle
                  class="text-center mb-2">
                  <div
                    class="my-1">
                    Email. {{ detail.delivery_receiver.email }}
                  </div>

                  <div>
                    Telepon. {{ detail.delivery_receiver.phone }}
                  </div>
                </v-card-subtitle>

                <v-card
                  flat
                  style="border: 2px dashed #eaeaea; border-radius: 5px;">
                  <v-card-text>
                    <div
                      class="d-flex align-center mb-1">
                      <div>
                        Kode
                      </div>

                      <v-spacer />

                      <div>
                        {{ detail.delivery_kode }}
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-1">
                      <div>
                        No. Reg Ajuan
                      </div>

                      <v-spacer />

                      <div>
                        {{ detail.delivery_ajuan_no_reg }}
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-1">
                      <div>
                        Status
                      </div>

                      <v-spacer />

                      <div>
                        {{ detail.delivery_status }}
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-1">
                      <div>
                        Resi
                      </div>

                      <v-spacer />

                      <div>
                        {{ detail.delivery_resi !== '' ? detail.delivery_resi : '-' }}
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-1">
                      <div>
                        Group
                      </div>

                      <v-spacer />

                      <div>
                        {{ detail.delivery_proses_kode !== '' ? detail.delivery_proses_kode : '-' }}
                      </div>
                    </div>

                    <v-divider 
                      class="my-4"
                      style="border-top: 2px dashed #eaeaea;"/>
                    
                    <div
                      class="d-flex align-center mb-1">
                      <div>
                        Alamat
                      </div>

                      <v-spacer />

                      <div
                        class="one-line">
                        {{ detail.delivery_receiver.address }}
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-1">
                      <div>
                        Provinsi
                      </div>

                      <v-spacer />

                      <div>
                        {{ detail.delivery_receiver.province }}
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-1">
                      <div>
                        Kabupaten
                      </div>

                      <v-spacer />

                      <div>
                        {{ detail.delivery_receiver.city }}
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-1">
                      <div>
                        Kecamatan
                      </div>

                      <v-spacer />

                      <div>
                        {{ detail.delivery_receiver.subdistrict }}
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-1">
                      <div>
                        Kelurahan
                      </div>

                      <v-spacer />

                      <div>
                        {{ detail.delivery_receiver.village }}
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-1">
                      <div>
                        Kode Pos
                      </div>

                      <v-spacer />

                      <div>
                        {{ detail.delivery_receiver.zipcode }}
                      </div>
                    </div>

                    <v-divider 
                      class="my-4"
                      style="border-top: 2px dashed #eaeaea;"/>

                    <div
                      class="d-flex align-center">
                      <div>
                        Diajukan
                      </div>

                      <v-spacer />

                      <div>
                        {{ detail.delivery_create_datetime | date }}
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <!-- <ValidationObserver 
                  ref="form">
                  <v-form 
                    class="text-left mt-7">
                    <ValidationProvider 
                      name="delivery" 
                      rules="required"
                      v-slot="{ errors, valid }">
                      <v-select
                        outlined
                        dense
                        color="#ff64ad"
                        placeholder="Pilih Status Pengiriman"
                        
                        :items="status"
                        item-color="#ff64ad"

                        v-model="form.delivery[0].status"
                        :success="form.delivery[0].status !== '' && valid"
                        :error-messages="errors">
                      </v-select>
                    </ValidationProvider>
                  </v-form>
                </ValidationObserver>

                <v-card-actions
                  class="pa-0">

                  <v-btn
                    @click="save()"
                    :loading="process.form"
                    :disabled="process.form"
                    elevation="0"
                    block
                    class="body-2 font-weight-bold text-capitalize white--text"
                    color="orange">
                    <span
                      class="ml-1">
                      Ubah Status Pengiriman
                    </span>

                    <v-spacer />

                    <v-icon>mdi-truck-check</v-icon>
                  </v-btn>
                </v-card-actions> -->

                <v-card-actions v-if="detail.delivery_status === 'REQUEST' || detail.delivery_status === 'DIKOREKSI'"
                  class="pa-0 mt-6">

                  <v-btn
                    @click="dialog.verif = true"
                    elevation="0"
                    block
                    class="body-2 font-weight-bold text-capitalize white--text"
                    color="orange">
                    <span
                      class="ml-1">
                      Proses Sekarang ?
                    </span>

                    <v-spacer />

                    <v-icon>mdi-truck-check</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <v-col 
              cols="12"
              md="9"
              class="pb-0">
              <v-tabs
                v-model="selected.menu"
                background-color="transparent"
                color="#ff64ad"
                slider-size="5"
                show-arrows
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                dense
                grow
                class="d-flex justify-start tabs-stream mt-6 ml-6">
                <v-tab
                  v-for="(item, index) in menu"
                  :key="index"
                  class="px-0 mr-4 d-flex align-center">
                  <v-avatar
                    tile
                    size="20">
                    <v-img 
                      contain
                      :src="item.icon">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            size="20"
                            color="#ff64ad">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span 
                    class="body-2 text-capitalize ml-2" 
                    :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                    {{ item.text }}
                  </span>
                </v-tab>
              </v-tabs>

              <v-card
                class="pa-2"
                min-height="78vh"
                style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
                      border-radius: 0px 10px 10px 10px;">
                <v-card-title
                  class="text-h5 font-weight-bold mb-1">
                  #{{ detail.delivery_kode }}
                </v-card-title>

                <v-card-subtitle
                  class="mb-2">
                  Status Pengiriman - 
                  
                  <span
                    class="font-weight-bold"
                    :class="detail.delivery_status === 'REQUEST' ? 'orange--text' :
                            detail.delivery_status === 'DIKOREKSI' ? 'lime--text' :
                            detail.delivery_status === 'DIPROSES' ? 'blue--text' :
                            detail.delivery_status === 'DISORTIR' ? 'green--text' : 'red--text'">
                    {{ detail.delivery_status }}
                  </span>
                </v-card-subtitle>

                <v-card-text
                  class="pb-0"
                  style="opacity: 80%;">
                  <v-icon small>mdi-calendar-month</v-icon>

                  Diajukan pada Tanggal <b>{{ detail.delivery_create_datetime | date }}</b> Pukul <b>{{ detail.delivery_create_datetime | time }}</b>
                </v-card-text>

                <!-- INFORMASI -->
                <div v-if="selected.menu === 0">
                  <v-card-text>
                    <v-list 
                      flat 
                      color="transparent"
                      three-line>
                      <v-list-item-group>
                        <v-skeleton-loader
                          v-for="(item, index) in process.load ? 5 : detail.delivery_item"
                          :key="index"
                          class="ma-auto"
                          :loading="process.load"
                          type="list-item-avatar-three-line">
                          <template>
                            <div>
                              <v-list-item v-if="!process.load && detail.delivery_item.length > 0"
                                :class="index < detail.delivery_item.length - 1 ? 'mb-4' : ''"
                                class="pl-3"
                                style="border-radius: 5px;
                                      border: 2px solid #eaeaea; 
                                      border-style: dashed;
                                      background: #fff;
                                      cursor: auto;">
                                <v-list-item-avatar 
                                  tile 
                                  size="50"
                                  class="mr-3">
                                  <v-img 
                                    style="border-radius: 5px;"
                                    alt="kominfo" 
                                    :src="require(`@/assets/image/service/${item.delivery_item_layanan_kode}.png`)"
                                    class="ma-auto">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          indeterminate 
                                          color="#ff64ad">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                  <v-list-item-title 
                                    class="body-2 font-weight-bold">
                                    {{ item.delivery_item_layanan_kode }} - {{ item.delivery_item_prod_nomor }}
                                  </v-list-item-title>

                                  <v-list-item-subtitle 
                                    class="caption font-weight-light black--text my-2" 
                                    style="opacity: 60%;">
                                    <div>
                                      <span
                                        class="one-line text-uppercase">
                                        {{ item.delivery_item_prod_nama }}
                                      </span>
                                    </div>
                                  </v-list-item-subtitle>

                                  <v-list-item-subtitle 
                                    class="caption font-weight-light black--text">
                                    <span
                                      class="one-line">
                                      {{ item.delivery_item_create_datetime | date }}
                                    </span>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </div>
                          </template>
                        </v-skeleton-loader>
                      </v-list-item-group>
                    </v-list>
                  </v-card-text>

                  <v-card-text v-if="detail.delivery_receiver.images.length > 0"
                    class="pb-2">
                    <v-divider
                      style="border: 3px solid #ff64ad;
                          border-radius: 50px;
                          width: 100px;" />
                    
                    <div
                      class="body-1 font-weight-bold black--text my-2 mb-3">
                      Data Dukung
                    </div>

                    <v-row>
                      <v-col
                        v-for="(item_file, index_file) in detail.delivery_receiver.images"
                        :key="index_file"
                        cols="12"
                        md="3">
                        <v-img
                          width="100%"
                          height="200"
                          alt="vuetify"
                          gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                          :src="item_file.url"
                          style="border-radius: 10px;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#ff64ad">
                              </v-progress-circular>
                            </v-row>
                          </template>

                          <a
                            :href="item_file.url"
                            target="_blank">
                            <v-icon
                              class="cursor-pointer pa-2"
                              size="30"
                              color="white"
                              style="position: absolute;
                                    top: 0px;
                                    right: 35px;">
                              mdi-download
                            </v-icon>
                          </a>

                          <v-icon 
                            @click="dialog.zoom = true; selected.zoom_file_id = item_file.file_id;"
                            class="cursor-pointer pa-2"
                            size="30"
                            color="white"
                            style="position: absolute;
                                  top: 0px;
                                  right: 0px;">
                            mdi-fullscreen
                          </v-icon>
                        </v-img>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </div>

                <!-- LOG -->
                <div v-if="selected.menu === 1">
                  <v-card-text
                    class="pl-0 py-0">
                    <v-timeline
                      align-center
                      dense>
                      <v-timeline-item
                        v-for="(item, index) in process.log ? 5 : list"
                        :key="index"
                        :color="item.color"
                        small>
                        <v-skeleton-loader
                          :loading="process.log"
                          type="list-item-avatar-three-line">
                          <div>
                            <v-row v-if="!process.log && list.length > 0">
                              <v-col 
                                cols="2">
                                <div
                                  class="body-1 font-weight-bold black--text"
                                  style="opacity: 60%;">
                                  {{ item.created_at | time }}
                                </div>
                              </v-col>

                              <v-col>
                                <div
                                  class="body-1 font-weight-bold"
                                  :style="`color: ${item.color};`">
                                  {{ item.status }}
                                </div>

                                <div
                                  class="body-2 font-weight-light line-text-second my-1 log_note"
                                  style="opacity: 60%;">
                                  <span
                                    v-html="item.msg">
                                  </span>
                                </div>

                                <div 
                                  class="body-2 font-weight-bold black--text"
                                  style="opacity: 60%;">
                                  {{ item.created_at | date }}
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                        </v-skeleton-loader>
                      </v-timeline-item>
                    </v-timeline>
                  </v-card-text>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </section>
    </v-flex>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        rotation: 0,
        dialog: {
          snackbar: false,
          fullscreen: false,
          zoom: false,

          verif: false,
          rejected: false
        },

        selected: {
          menu: 0,

          zoom_index: 0,
          zoom_file_id: '',
          zoom_array: []
        },

        menu: [
          {
            text: 'Informasi',
            icon: require('@/assets/image/info.png')
          },
          {
            text: 'Progres',
            icon: require('@/assets/image/step.png')
          }
        ],

        status: [
          'REQUEST',
          'DIPROSES',
          'DISORTIR',
          'DIKEMAS',
          'DIKIRIM',
          'SELESAI',
          'DITOLAK'
        ],

        detail: {},

        list: [],

        form: {
          delivery: [
            {
              delivery_kode: '',
              status: 'DIPROSES',
              note: ''
            }
          ]
        },

        process: {
          load: false,

          form: false,

          log: false
        },

        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      'selected.menu': function(val) {
        if (val === 1) {
          this.fetchLogPOS()
        }
      },

      'selected.zoom_file_id':function(val) {
        this.selected.zoom_index = this.selected.zoom_array.findIndex(x => x.file_id === val)
      },

      'selected.zoom_index':function() {
        this.rotation = 0
      }
    },
    computed: {
      
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }
        
        this.selected.zoom_array = []

        await get(`delivery`, { params })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.load = false
            
            this.detail = res.data[0]

            this.form.delivery[0].delivery_kode = this.detail.delivery_kode

            let arr = this.detail.delivery_receiver.images

            arr.map(obj => {
              this.selected.zoom_array.push({
                file: obj.url,
                file_id: obj.file_id
              })
            })
          }
        })
      },

      async fetchLogPOS () {
        this.process.log = true

        let params = {
          ajuan_no_reg: this.detail.delivery_ajuan_no_reg
        }

        this.list = []

        await get(`delivery/log`, { params })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            // this.process.log = false

            // this.list = res.data

            let data = res.data
            
            data.forEach(obj => {
              this.list.push({
                no_reg: obj.no_reg,
                status: obj.status,
                msg: obj.status !== 'DITOLAK' ? obj.msg : obj.note,
                created_at: obj.created_at,
                color: obj.status === 'REQUEST' ? '#FF9800' :
                       obj.status === 'DIKOREKSI' ? '#CDDC39' :
                       obj.status === 'DIPROSES' ? '#2196F3' :
                       obj.status === 'DISORTIR' ? '#4CAF50' :
                       obj.status === 'DITOLAK' ? '#F44336' : '#009688'
              })
            })

            if(Object.keys(this.detail).length > 0 && this.detail.delivery_resi !== '' && this.list[0].status === 'DISORTIR') {
              this.fetchTrack()
            } else {
              this.process.log = false
            }
          }
        })
      },

      async fetchTrack () {
        let array_track = []

        await post(`delivery/getTrackAndTrace`, { 
          data: {
            resi: this.detail.delivery_resi
          }
        })
        .then((response) => {
          let res = response.data

          if (res.code === 200) {
            this.process.log = false
            
            let data = res.data

            data.forEach(obj => {
              array_track.push({
                no_reg: this.list[0].no_reg,
                status: obj.eventName,
                msg: obj.description,
                created_at: obj.eventDate,
                color: obj.eventName.includes('POSTING LOKET') ? '#9C27B0' :
                       obj.eventName.includes('MANIFEST SERAH') ? '#673AB7' :
                       obj.eventName.includes('MANIFEST TERIMA') ? '#03A9F4' :
                       obj.eventName.includes('PROSES ANTAR') ? '#3F51B5' : '#009688'
              })
            })

            array_track = array_track.toReversed()

            this.list = [...array_track, ...this.list]
          }
        })
      },

      async save(type) {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          this.form.delivery[0].status = type

          if (type === 'DIPROSES') this.form.delivery[0].note = ''

          // SAVE TO REST API
          await post(`delivery/updateStatus`, {
            data: this.form,
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.verif = false

              this.dialog.rejected = false

              this.fetchDetail()

              this.fetchLogPOS()
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      rotateRight() {
        this.rotation += 90
      },
      rotateLeft() {
        this.rotation -= 90
      }
    }
  }
</script>

<style>
  .v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
    min-height: 64vh;
    left: calc(24px - 1px);
  }

  .v-timeline-item__divider {
    min-width: 50px;
    justify-content: start !important;
    left: -34px;
  }

  .log_note p {
    margin-bottom: 2px;
  }
</style>